<template>
  <v-container class="mt-4  pr-4">
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
        	<v-card-title>
	          <v-spacer></v-spacer>
	          <span class="text-subtitle-1">
	            <strong>Mis Reservaciones</strong>
	          </span>
	          <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
	        </v-card-title>

          <v-card-text>
	          <v-row>

	            <v-alert
	              dense
	              outlined
	              type="warning"
	              v-if="!progra.length"
	            >
	              No existen clases programadas para este día!
	            </v-alert>

              <v-col cols="12" md="6"  v-for="(clase, i ) in progra" :key="i">
                <v-card class="shadowCard">
                  <v-card-text class="pa-0">
                    <v-list-item three-line>
                      <v-list-item-content class="pb-0">
                        <div class="text-overline mb-4">
                          <v-chip :color="clase.color" small dark> {{ clase.categoria }} </v-chip>
                        </div>
                        <div> <b>Día:</b> {{ clase.dia }}</div>
                        <br/>
                        <div>  <b>Hora:</b> {{ clase.hora_inicio.substr(0,5) + ' a ' + clase.hora_fin.substr(0,5) }}</div>
                        <br/>
                        <div> <b>Quedan:</b> {{ clase.restan }} lugares</div>
                        <br/>
                        <div>
                          <strong>Coach: {{ clase.nombre_completo }}</strong>
                          <br/>
                          <br/>
                          {{ clase.detalles }}
                        </div>
                      </v-list-item-content>

                      <v-list-item-avatar
                        tile
                        size="80"
                        color="transparent"
                      >
                        <v-avatar
                          size="80"
                          color="grey"
                        >
                          <img :src="url + clase.foto" />
                        </v-avatar>
                      </v-list-item-avatar>
                    </v-list-item>
                    <br/>

                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-btn
                      tile
                      color="green"
                      small
                      dark
                      block
                      outlined
                      v-if="clase.estado_clase == 'Corriendo'"
                      @click="generarQRCode( clase )"
                    >
                      Corriendo
                      <v-icon small right> mdi-calendar </v-icon>
                    </v-btn>

                    <v-btn
                      tile
                      color="red"
                      small
                      dark
                      block
                      outlined
                      v-if="clase.estado_clase == 'Por iniciar'"
                      @click="generarQRCode( clase )"
                    >
                      Por iniciar
                      <v-icon small right> mdi-calendar </v-icon>
                    </v-btn>


                    <v-btn
                      tile
                      color="orange"
                      small
                      dark
                      outlined
                      v-if="clase.estado_clase == 'Pendiente'"
                    >
                      Pendiente
                      <v-icon small right> mdi-calendar </v-icon>
                    </v-btn>

                    <v-btn
                      tile
                      color="grey"
                      small
                      dark
                      block
                      outlined
                      v-if="clase.estado_clase == 'Terminada'"
                    >
                      Terminada
                      <v-icon small right> mdi-calendar </v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                      tile
                      color="black"
                      small
                      dark
                      outlined
                      v-if="clase.estado_clase == 'Pendiente'"
                      @click="claseSeleccionada = clase, dialogCancelar = true"
                    >
                      Cancelar Reserv.
                      <v-icon small right> mdi-calendar </v-icon>
                    </v-btn>

                  </v-card-actions>
                </v-card>
              </v-col>
	          </v-row>
	        </v-card-text>

        </v-card>
      </v-col>
    </v-row>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialog"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
        </v-card-title>

        <v-card-text class="text-h5 text-center">
          ¿Estás seguro de realizar está reservación?
        </v-card-text>

        <v-card-actions>
          <v-btn color="yellow" small tile @click="dialog = false">
            Cancelar
            <v-icon small right>mdi-cancel</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green" dark small tile @click="saveReservacion()">
            Sí
            <v-icon small right>mdi-check</v-icon>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>

    <!-- Dialogo de editar o agregar-->
    <v-dialog
      v-model="dialogQr"
      max-width="400px"
      persistent
    >
      <v-card>
        <v-card-title>
        </v-card-title>

        <v-card-text class="text-h5 text-center">
          <v-img :src="qrImagen"></v-img>
        </v-card-text>

        <v-card-actions>
          <v-alert
			      dense
			      outlined
			      type="info"
			    >
			      Pasa el codigo QR por la cámara para tomar tu asistencia!
			    </v-alert>
        </v-card-actions>
        <v-btn 
          color="transparent elevation-0"
          x-small
          absolute
          top
          right
          fab
          class="mt-5 mr-0"
          @click="dialogQr = false"
         ><v-icon>mdi-close</v-icon>
        </v-btn>

      </v-card>
    </v-dialog>

    <!-- Dialogo para eliminar -->
    <v-dialog v-model="dialogCancelar" max-width="500px">
      <v-card>
        <v-card-text>
          <v-row justify="space-around">
            <v-col cols="7">
              <v-card class="elevation-0" height="100%" style="display: table;">
                <div class="text-subtitle-1" style="display: table-cell; vertical-align: middle;">
                  ¿Estás seguro que deseas cancelar está reservación?
                </div>
              </v-card>
            </v-col>
            <v-col cols="5">
              <v-img src="@/assets/borrar.png"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-6">
          <!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
          <v-btn color="error" text  class="mr-2" @click="dialogCancelar = false">No, cancelar</v-btn>
          <v-spacer></v-spacer>
          <!-- Guardar la información  -->
          <v-btn color="#5C5C5C"  dark class="elevation-6"  @click="deleteItemConfirm()">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

	import QRCode from 'qrcode';

  export default {

    mixins: [ validarErrores, funcionesExcel ],

    components:{
      Alerta,
      carga,
    },

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      defaultItem: {
        idpaquetes:0,
        paquete:'',
        cant_clases:0,
        costo:0,
        limite_dias:0,
        deleted:0,
        fecha_creacion:null,
      },

      // tabla
      paquetes: [],

      libres: 0,
      progra:[],

      url: false,

      clase: null,

      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      dialogQr: false,
      qrImagen: null,
      dialogCancelar: false,
      claseSeleccionada: null
    }),

    computed: {
      ...mapGetters('login',['getdatosUsuarioFitHouse']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar categoria' : 'Editar categoria'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      fecha(){ this.initialize() }

    },

    async created () {
      this.url = this.$http.options.root + 'fotos-fithouse/'
      await this.initialize()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.progra = []  

        let payload = {
          dia           : this.fecha,
          idusuarios    : this.getdatosUsuarioFitHouse.idusuarios,
        }     

        return this.$http.post('programacion.usuario', payload ).then(response=>{
          this.progra = response.data.filter( el => el.idreservaciones )
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.paquetes.indexOf(item)
        this.editedItem = Object.assign({}, item)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      deleteItemConfirm( ){
        this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('programacion.reservacion.update', this.claseSeleccionada).then(response=>{
          this.initialize()
          this.dialogCancelar = false
          this.validarSuccess('Actualización correcta')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      formatoMoneda(monto) {
        const formato = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        });

        return formato.format(monto);
      },

      openView( pago ){
        window.open( pago.url_pago )
      },

      previaReserva ( clase ) {
        if( this.editedItem.cant_clases_restantes > 0  ){
          this.clase = clase
          this.dialog = true
        }else{
          this.validarErrorDirecto('Tu paquete ya no cuenta con clases disponibles, por favor, selecciona otro paquete o realiza la compra de alguno.')
        }
      },

      previousDay () {
        const siguienteDia = new Date(this.fecha);
        siguienteDia.setDate(siguienteDia.getDate() - 1);
        this.fecha = siguienteDia.toISOString().substr(0, 10);
      },
      
      nextDay () {
        const siguienteDia = new Date(this.fecha);
        siguienteDia.setDate(siguienteDia.getDate() + 1);
        this.fecha = siguienteDia.toISOString().substr(0, 10);
      },

      saveReservacion( ){
        const payload = {
          idpago        : this.editedItem.idpagos,
          idusuarios    : this.getdatosUsuarioFitHouse.idusuarios,
          idprogramacion: this.clase.idprogramacion,
        }

        this.cargar = true
        // Lo mandapos por el EP
        this.$http.post('programacion.reservacion', payload).then(response=>{
          this.editedItem.cant_clases_restantes - 1
          this.initialize()
          this.getProgramacionDia()
          this.dialog = false
          this.validarSuccess('Para ver tu reservación, ve a tu calendario!')
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      generarQRCode( clase ) {
		    const qrData = {
	        idusuarios     : this.getdatosUsuarioFitHouse.idusuarios,
	        idreservaciones: clase.idreservaciones,
	        idprogramacion : clase.idprogramacion
	      };

	      const qrString = JSON.stringify(qrData);

	      QRCode.toDataURL(qrString).then(url => {
          // Hacer algo con la URL del código QR, como mostrarla en una imagen
		    	this.dialogQr = true
          this.qrImagen = url
        })
        .catch(err => {
          console.error(err);
        });

		  }
    },
  }
</script>


